import { JRCTypography } from 'components/JRCTypography/JRCTypography';
import * as React from 'react';
import { JRCConditionalWrapper } from '../Common/JRCConditionalWrapper';
import { JRCTooltip, JRCTooltipProps } from '../JRCTooltip/JRCTooltip';

export type JRCEllipsisProps = {
    label?: string;
    length: number;
    position?: JRCTooltipProps['position'] | 'none';
};

export const JRCEllipsis = ({ label, length, position }: JRCEllipsisProps) => {
    if (!label) return <></>;

    // Using an array to count double characters correctly
    const labelArr = [...label];

    return (
        <JRCConditionalWrapper
            condition={labelArr.length > length}
            wrapper={() =>
                position === 'none' ? (
                    `${labelArr.slice(0, length).join('')}…`
                ) : (
                    <JRCTooltip description={label} position={position}>
                        {labelArr.slice(0, length).join('')}…
                    </JRCTooltip>
                )
            }>
            <JRCTypography>{label}</JRCTypography>
        </JRCConditionalWrapper>
    );
};
